module.exports = __webpack_public_path__ + "img/pse.4633b70.png";